<template lang="pug">
  .-answers-analytics__users
    .-answers-analytics__users-row
      .-answers-analytics__users-col( v-for="item in header" :key="item" )
        .-answers-analytics__users-header
          | {{ item }}
    TableUserRow(
      v-for="( user, idx) in data"
      :key="idx+'userData'"
      :tariffs="tariffs"
      :user="user"
    )
</template>
<script>
import TableUserRow from './TableUserRow';
export default {
  components: { TableUserRow },
  props: ['data', 'tariffs'],
  data() {
    return {
      header: ['Имя ученика', 'Продукт', 'Название урока', 'Дата проверки']
    };
  }
};
</script>
